export interface IDataInsightsProps {
  shopId: number;
}
export enum KPITypesEnum {
  Impressions = 'impressions',
  Revenue = 'syteRevenue',
  ARPU = 'arpu',
  CTR = 'ctr',
  CVR = 'cvr',
  AOV = 'aov',
}

export enum ChartType {
  Bar = 'bar',
  Doughnut = 'doughnut',
}
